var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1db50f4afc16b4587495fd5fa43a8d95624c6ac1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kelp-dapp@staderlabs"]={id:"1db50f4afc16b4587495fd5fa43a8d95624c6ac1"};
      